import * as React from "react";

import { ResponsivenessSetting, useResponsiveness } from "../hooks";

import { useProductListPresentationModel } from "../providers";

import { MobileMasonryColumnSelector } from "./MobileMasonryColumnSelector";

const calculateIsTablet = () => {
  if (window.matchMedia("(max-width: 1023px) and (min-width: 768px)").matches) {
    return true;
  }
  return false;
};

export const MobileInfoBar: React.FunctionComponent = () => {
  const [responsivenessSetting] = useResponsiveness();

  const { productCount } = useProductListPresentationModel();

  const [showMasonryColumnSelect, setShowMasonryColumnSelect] = React.useState(
    !calculateIsTablet()
  );

  const tablet = () => {
    setShowMasonryColumnSelect(false);
  };
  const notTablet = () => {
    setShowMasonryColumnSelect(true);
  };
  React.useEffect(() => {
    if (calculateIsTablet()) {
      tablet();
    } else {
      notTablet();
    }

    const handleResize = () => {
      if (calculateIsTablet()) {
        tablet();
      } else {
        notTablet();
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      notTablet();
    };
  }, []);

  return (
    <div
      className={`mobile-info-bar ${
        productCount < 1 ? "has-no-products" : "has-products"
      } ${
        responsivenessSetting === ResponsivenessSetting.Mobile
          ? "actually-on-a-mobile"
          : ""
      }`}
    >
      <p className="product-count">
        Displaying {productCount} item{productCount === 1 ? "" : "s"}
      </p>
      {showMasonryColumnSelect && <MobileMasonryColumnSelector />}
    </div>
  );
};
